export default __webpack_public_path__ + "static/media/DJI_0645-estate-homesites-2400x800.d85146b0.jpg";